import { Component } from '@angular/core';
import { MergeExamDifferenceChecker } from './merge-exam-difference-checker';

@Component({
    selector: 'merge-exam',
    templateUrl: './merge-exam.component.html',
    styleUrls: ['./merge-exam.component.scss']
})
export class MergeExamComponent {

    loading = false;
    message: string;

    constructor(
        public mergeExamDifferenceChecker: MergeExamDifferenceChecker) {
    }
}
